export const applyCellStyle = ({ columnInstance }) => {
  /**
    * This function is designed to add a clear filter button to the last column in an ag-Grid configuration.
    * It iterates through the columns and applies a custom header component to the last column.
    * This is useful for enhancing the user experience by providing a consistent way to clear filters directly
    * from the column header, improving data interaction and visibility.
    */

    return columnInstance.map((column, columnIndex) => {
      if (column.cellDataType) {
        if (column.cellDataType === 'number') {
          return {
            ...column,
            cellStyle: { textAlign: 'right' },
          };
          /*
           In order to use an action column in the OpDatagrid and automatically remove its context,
           it must be explicitly defined in the column definition of the grid instance.

            The `columnDef` for an action column should look like this:

            const columnDef = [{
              cellDataType: "text",  // Explicitly set cellDataType to "text"
              field: "action"       // The field representing the action column
            }]

            Note:
            - The `cellDataType` for the action column should be set to `"text"`, 
              as AG Grid does not recognize `"action"` as a valid cell data type.
            - This change from `cellDataType: "action"` to `cellDataType: "text"` 
              is necessary to avoid errors or warnings related to the column type.
        */
        } else if (column.cellDataType === 'text' && column.field === 'action') { 
          // remove cellDatatype so ag-grid can infer other data type of cells based on its cell value
          delete column.cellDataType;
          return {
            ...column,
            cellClass: 'ag-text-align-center suppress-cell-selection-border',
            filter: false,
            headerName: ' ',
            lockVisible: true,
            sortable: false,
            suppressColumnsToolPanel: true,
            suppressHeaderContextMenu: true,
            suppressHeaderMenuButton: true,
            suppressNavigable: true,
            onCellContextMenu: (params) => {
              params.api.hidePopupMenu();
            }
          };
        }
      } 
      return column;
    });
}